import { useState } from "react";
import { useAsync } from "react-async";
import { useLocation, useParams } from "react-router-dom";
import CalendarItem from "../../api/models/calendarItem";
import { EventSource } from '../../types/eventSource';
import { getCalendarItemsByDistrictId } from "../../api/services/calendarItemService";
import ReadonlyCalendar from "../../components/calendar/readonly";
import { calendarColorCodes } from '../../common/constants';
import Layout from "../../components/layout";
import EditModal from '../../components/editModal';
import { useAppSelector } from "../../app/hooks";

type Params = { id: string; };
type ViewState = { districtName?: string; };

const fetchCalendarItemsByDistrictId = async ({ id }: any) => await getCalendarItemsByDistrictId(id);

const ReadonlyCalendarPage = () => {
    const { state } = useLocation<ViewState>();
    const { id } = useParams<Params>();
    const districtId = Number(id);
    const [calendarEvents, setCalendarEvents] = useState<EventSource[]>([]);
    const [calendarItems, setCalendarItems] = useState<CalendarItem[]>([]);
    const [calendarNotes, setCalendarNotes] = useState('');
    const [openCalendarNotesModal, setOpenCalendarNotesModal] = useState(false);
    //const [isOperationsUser, setIsOperationsUser] = useState<boolean>(false);
    const userRoles = useAppSelector((s) => s.user.roles);

    //Get calendar items for this district
    useAsync({
        promiseFn: fetchCalendarItemsByDistrictId,
        id: districtId,
        onResolve: (r) => {
            //Generate calendar items
            let items: CalendarItem[] = [];
            let events: EventSource[] = [];
            if (r.data.calendarItems && r.data.calendarItems.length > 0) {
                r.data.calendarItems.map((c, i) => {
                    const startDate = new Date(c.startDate);
                    const endDate = new Date(c.endDate);
                    const item: CalendarItem = {
                        calendarItemId: Number(c.calendarItemId),
                        title: c.title,
                        startDate: startDate,
                        endDate: endDate,
                        colorCode: c.colorCode,
                        notes: c.notes,
                        isVisible: true
                    };
                    items.push(item);

                    const event: EventSource = {
                        id: c.calendarItemId?.toString() ?? '0',
                        start: startDate,
                        end: endDate,
                        title: item.title,
                        backgroundColor: calendarColorCodes[item.colorCode].hexCode,
                        notes: c.notes
                    };
                    events.push(event);
                    return true;
                });

                setCalendarItems(items);
                setCalendarEvents(events);

                return true;
            }
        }
    });

    return (
        <Layout>
            <div className="px-4 py-3 mt-1 bg-white rounded-lg shadow readonly-calendar-page">
                <EditModal
                    open={openCalendarNotesModal}
                    allowRemove={false}
                    onCancel={() => setOpenCalendarNotesModal(false)}
                >
                    <div className='flex space-x-3'>
                        <h3>{calendarNotes}</h3>
                    </div>
                </EditModal>
                <h1 className="font-bold">{state.districtName}</h1>
                <div className="flex w-full h-full calendar-wrapper">
                    <ReadonlyCalendar
                        calendarEvents={calendarEvents}
                        eventClick={(e) => {
                            //if (!isOperationsUser) {
                            setCalendarNotes(e.event.extendedProps.notes === '' ? 'No notes ' : e.event.extendedProps.notes);
                            setOpenCalendarNotesModal(true);
                            //}
                        }}
                    />
                </div>
            </div>
        </Layout>
    )
}

export default ReadonlyCalendarPage;